import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Sep 10 2018
 * @author SKu
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { jsonConversions, TierConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import { GenericTransportLayer } from '../GenericTransportLayer';
/**
 * Transport layer for tier component
 * use GenericTransportLayer for standart fletching data(getAll, getOne),
 * and own custom methods for create, update and delete tiers
 */

export var TierLayer =
/*#__PURE__*/
function (_GenericTransportLaye) {
  _inherits(TierLayer, _GenericTransportLaye);

  /** Creating base Uri */
  function TierLayer() {
    _classCallCheck(this, TierLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(TierLayer).call(this, "".concat(CONSTANTS.API.ENDPOINTS.TIERS)));
  }

  _createClass(TierLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
    /**
     * FIXME:
     * @param response
     */

  }, {
    key: "convertTiers",
    value: function convertTiers(response) {
      var _this = this;

      var updatedTiers = [];
      (response.data.result || []).map(function (updatedTire) {
        updatedTiers.push(_this.getConverter().toObject(updatedTire, jsonConversions));
      });
      return updatedTiers;
    }
    /**
     * Method creates new tier
     * As response gets all existed tiers in random order
     * @param item - new tier that you want to create
     */

  }, {
    key: "create",
    value: function create(item) {
      var _this2 = this;

      var createPromise = api("".concat(this.baseUri)).post(this.getConverter().toDocument(item, jsonConversions), {
        responseType: 'json'
      }).then(function (response) {
        return _this2.convertTiers(response);
      }).catch(function (error) {
        return Promise.reject(error);
      });
      return createPromise;
    }
    /**
     * Method updates tier
     * As response gets all existed tiers in random order
     * @param item -  tier that you want to update
     */

  }, {
    key: "update",
    value: function update(item) {
      var _this3 = this;

      var updatePromise = api("".concat(this.baseUri, "/").concat(item.id)).put(this.getConverter().toDocument(item, jsonConversions), {
        responseType: 'json'
      }).then(function (response) {
        return _this3.convertTiers(response);
      }).catch(function (error) {
        return Promise.reject(error);
      });
      return updatePromise;
    }
    /**
     * Method deletes tier
     * As response gets object with parameter{delete: boolean}
     * @param id -  id of tier that you want to delete
     */

  }, {
    key: "delete",
    value: function _delete(id) {
      var _this4 = this;

      var deletePromise = api("".concat(this.baseUri, "/").concat(id)).delete({
        responseType: 'json'
      }).then(function (response) {
        return _this4.convertTiers(response);
      }).catch(function (error) {
        return Promise.reject(error);
      });
      return deletePromise;
    }
  }]);

  return TierLayer;
}(GenericTransportLayer);

__decorate([Inject, __metadata("design:type", TierConverter)], TierLayer.prototype, "converter", void 0);